import React from "react";
import { FaTelegramPlane, FaDiscord} from "react-icons/fa"; // เพิ่ม Social Icons

const Footer = () => {
  return (
    // เปลี่ยน Background ให้แมตช์กับ Theme
    <footer id="contact" className="bg-slate-900 text-white mt-auto py-16 md:py-24 px-6 md:px-10 border-t border-white/10">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-16 items-start text-left">
        
        {/* คอลัมน์ที่ 1: Logo & Brief Bio ( Typography เด่นที่สุด) */}
        <div className="md:col-span-1 space-y-6">
          <a href="itsmejustin.space" className="text-white font-black italic text-3xl tracking-tighter hover:scale-105 transition-transform inline-block">
            JUSTIN<span className="text-yellow-500">.</span>
          </a>
          <p className="text-slate-400 max-w-sm text-base md:text-lg leading-relaxed font-medium">
            Building Fullstack solutions for the decentralized future—from High-End Web Apps to Autonomous Crypto Infrastructure.
          </p>
        </div>

        {/* คอลัมน์ที่ 2: Contact Me (จัดกลุ่ม Link ใหม่) */}
        <div className="md:col-span-1 space-y-8">
          <h4 className="text-yellow-500 font-black tracking-[0.4em] uppercase text-xs italic">
            GET IN TOUCH
          </h4 >
          <div className="space-y-4 text-white/70 font-bold uppercase tracking-widest text-sm">
            <a href="mailto:j.donlatam@gmail.com" className="hover:text-yellow-500 transition-colors block">
              j.donlatam@gmail.com
            </a>
            <p>+66 64 229 6949</p>
          </div>
        </div>

        {/* คอลัมน์ที่ 3: Social & Copyright (ใช้ Icons เพิ่มความ Tech) */}
        <div className="md:col-span-1 space-y-8 text-left">
          <h4 className="text-yellow-500 font-black tracking-[0.4em] uppercase text-xs italic">
            FOLLOW MY JOURNEY
          </h4>
          <div className="flex gap-6 items-center">
            {[
              { icon: FaTelegramPlane, url: "https://t.me/justerlin" },
              { icon: FaDiscord, url: "https://discord.com/users/326603470507474944" },
              // { icon: FaTwitter, url: "https://twitter.com/tidusfolio" }
            ].map((social, i) => (
              <a key={i} href={social.url} target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-yellow-500 transition-colors">
                <social.icon size={28} />
              </a>
            ))}
          </div>
           <p className="text-white/40 text-[10px] md:text-xs font-medium tracking-widest mt-12">
            © 2026 JUSTIN FOLIO. <br className="hidden md:block"/>ALL RIGHTS RESERVED.
          </p>
        </div>

      </div>
    </footer>
  );
};

export default Footer;